import React from 'react'
import LoadingScreen from 'src/components/shared/LoadingScreen'

const ChecklistAccessGate = ({ scopeMatches, error, isLoading, children }) => {
  if (!scopeMatches) return <LoadingScreen />
  if (error) {
    const status = error.status
    const message =
      status === 401
        ? 'Please log in to view this order.'
        : status === 403
        ? 'You do not have access to this supplier order.'
        : 'Unable to load this order. Please try again.'
    return (
      <div role='alert' style={{ padding: 32, textAlign: 'center' }}>
        <p>{message}</p>
        {status === 401 ? (
          <a href='/login'>Log in</a>
        ) : status === 403 ? (
          <a href='/supplier/orders'>Back to your orders</a>
        ) : null}
      </div>
    )
  }
  if (isLoading) return <LoadingScreen />
  return <>{children}</>
}

export default ChecklistAccessGate
